import { useWorkspaceDetails } from "@api/workspace.api";
import { useScope } from "@state/scopeContext.lib";
import { useActiveWorkspaceDetails } from "./useActiveWorkspaceDetails";

export function useActiveWorkspace() {
    const activeWorkspaceDetails = useActiveWorkspaceDetails();
    return activeWorkspaceDetails?.workspace ?? null;
}

/** The active workspace and whether its details are still loading, so a failed request isn't mistaken for one in flight. */
export function useActiveWorkspaceQuery() {
    const { workspaceId } = useScope();
    const { data, isLoading } = useWorkspaceDetails(workspaceId);
    return { workspace: data?.workspace ?? null, isLoading };
}
